export default [
  {
    route: 'Mural',
    title: 'Dashboard',
    icon: 'HomeIcon',
    i18n: 'Mural',
    rule: 'dashboard'
  }
]
